module.exports = __webpack_public_path__ + "static/media/Training.18a86fdd.png";